<div *ngIf="newParameter == undefined">

    <div *ngIf="shareSavingsUser && shareSavingsUser.length > 0">

        <h5 class="my-1 text-center text-uppercase">Caja de Inversión Por Acciones</h5>
        <br>
        <mat-table #ssUserTable class="table" [dataSource]="shareSavingsUser">

            <ng-container matColumnDef="inversion">
                <mat-header-cell *matHeaderCellDef> Casa de Bolsa </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.user.investmentType }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="importe">
                <mat-header-cell *matHeaderCellDef> Importe de Ahorro </mat-header-cell>
                <mat-cell *matCellDef="let element"> $ {{element.contributionAmount }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cuotas">
                <mat-header-cell *matHeaderCellDef> Cuotas de Descuento </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.numberOfPayments }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="fecha">
                <mat-header-cell *matHeaderCellDef> Fecha Solicitud</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.dateS}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="activo">
                <mat-header-cell *matHeaderCellDef> Estatus </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="detalle" class="center-text">
                <mat-header-cell *matHeaderCellDef><span *ngIf="adminButton == true" >Admin</span></mat-header-cell>
                <mat-cell *matCellDef="let element">

                    <button *ngIf="element.active == true && (element.scheduleDateID == shareSavingsParameters.scheduleDateID || adminButton == true)" mat-icon-button color="primary"
                        (click)="detailssUser(element)">
                        <mat-icon aria-label="Delete">details</mat-icon> &nbsp; DETALLE
                    </button>

                </mat-cell>
            </ng-container>

            <mat-header-row mat-header-row *matHeaderRowDef="ssUserColumns"></mat-header-row>
            <mat-row mat-row *matRowDef="let row; columns: ssUserColumns;"></mat-row>

        </mat-table>

    </div>
    <!--solo va a estar habilitado en el ciclo de fecha y cuando el registro en el ciclo  sea null   -->
    <div class="m-4">
        <button *ngIf="newRegister && !firstRegisterEnabled" class="btn btn-block btn-primary" (click)="detailssUser()">
            Nuevo Registro de Ahorro Por Acciones
        </button>
    </div>
</div>

<div *ngIf="(newParameter!== undefined && newParameter.activeParameterID != undefined && newParameter.activeScheduleDateID != undefined ) || firstRegisterEnabled">
    <app-ss-user-registration [contentLocation]="contentLocation" [shareSavingsParameters]="shareSavingsParameters" [newParameter]="newParameter">
    </app-ss-user-registration>
</div>